export type GenderType = 'm' | 'f'

export const options = [
  {value: 'm'},
  {value: 'f'},
]
